import firebase from "firebase/compat/app";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";

import {
  getFirestore,
  query,
  getDocs,
  getDoc,
  collection,
  where,
  addDoc,
  doc,
  setDoc,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAGOlqnyXxPi5CdljtUrPG_WQ2puRv9VnI",
  authDomain: "no-food-waste-app.firebaseapp.com",
  projectId: "no-food-waste-app",
  storageBucket: "no-food-waste-app.appspot.com",
  messagingSenderId: "322173798965",
  appId: "1:322173798965:web:87b488c41851f25ad2ff7c",
  measurementId: "G-F96M3EMCVW",
};

// Use your config values here.
const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

console.log(auth);

//sign in with google
const googleProvider = new GoogleAuthProvider();
const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const registerWithEmailAndPassword = async (name, email, password) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    await setDoc(doc(db, "users", user.uid), {
      uid: user.uid,
      name,
      authProvider: "local",
      email,
      carbonData: [],
    });
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};

const getDataCollection = async (coleccion) => {
  const colRef = collection(db, coleccion); 
  let books = [];

  await getDocs(colRef)
    .then((snapshot) => {

      snapshot.docs.forEach((doc) => {
        doc.data().carbonData.forEach( (attribute) => {
          books.push(attribute);
        })
        
      })
      //Imprimo el contenido del arreglo que cree
    })
    .catch(err => {
      console.log(err.message)
      books = null;
    })

  return books;
}

export {
  firebaseApp,
  auth,
  db,
  getDataCollection,
  signInWithGoogle,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordReset,
  logout,
};
